import { render, staticRenderFns } from "./Competence.vue?vue&type=template&id=e40b78f8"
import script from "./Competence.vue?vue&type=script&lang=ts"
export * from "./Competence.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports